export default {
  getSupportRequestFilter: state => state.filter,
  getSupportRequestResult: state => state.result,
  getSupportRequestList: state => state.list,
  getSupportRequestMultipleSelection: state => state.multiSelect,
};
